import { Component, OnInit, Directive, ChangeDetectorRef } from "@angular/core";
import { ModalController, NavParams, NavController } from "@ionic/angular";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { AppService } from "src/app/app.service";
import { Global } from "../../../global";
import { Subject } from "rxjs";
// import { forEach } from '_node_modules/jszip';

@Component({
  selector: "app-datepicker-modal",
  templateUrl: "./people-modal.page.html",
  styleUrls: ["./people-modal.page.scss"],
})
export class PeopleModalPage implements OnInit {
  callingFilter: string;
  User_GUID: string;
  peopleList: any = [];
  peopleSelectedList: any = [];
  loadingDone: boolean = false;
  peopleSearchText: string;
  multiSelect = false;
  showSelected: boolean = false;
  ShowSelectedList: Array<Object>;
  //selectedPeople: any[] = [];
  peopleParamList: any = [];

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private formBuilder: FormBuilder,
    private appservice: AppService,
    public globals: Global,
    private navController: NavController,
    private cdRef: ChangeDetectorRef
  ) {
    this.peopleSearchText = "";
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }

  ngOnInit() {

    this.callingFilter = this.navParams.data.paramObject.callingFilter;
    this.User_GUID = this.navParams.data.paramObject.User_GUID;
    this.multiSelect = this.navParams.data.paramObject.multiSelect;
    //this.peopleParamList = this.navParams.data.paramObject.peopleList; //People group assign
    this.peopleSelectedList =
      this.navParams.data.paramObject.peopleSelectedList; //user assign Lesson builder

    this.GetPeopleList();
  }

  deselectAll() {
    this.peopleList.forEach((element) => {
      element.UserAssigned = false;
    });
    this.peopleSelectedList = [];
  }

  selectAll() {
    this.peopleList.forEach((element) => {
      let found = this.peopleSelectedList.find((x) => x.GUID == element.GUID);
      if (!found) {
        this.peopleSelectedList.push(element);
        element.UserAssigned = true;
      }
    });
  }

  inSelectedList(person: any) {
    let index = this.peopleSelectedList.findIndex((x) => x.GUID == person.GUID);
    //let foundPerson = this.peopleSelectedList[index];
    //found
    if (index > -1 && this.peopleSelectedList[index].UserAssigned == true)
      return true;
    //not found
    else return false;
  }

  selectPerson(event: any, person: any) {
    let index = this.peopleSelectedList.findIndex((x) => x.GUID == person.GUID);
    let foundPerson = this.peopleSelectedList[index];

    //found
    if (index > -1) {
      person.UserAssigned = !person.UserAssigned;
      this.peopleSelectedList[index] = person;
    }
    //not found
    else {
      this.peopleSelectedList.push(person);
      person.UserAssigned = true;
    }
  }

  ShowSelected() {
    this.showSelected = !this.showSelected;
    if (this.showSelected) {
      this.peopleSelectedList;
    } else {
      this.peopleList;
    }
  }

  GetPeopleList() {
    var subject = new Subject<any>();

    const formData: FormData = new FormData();

    formData.append("GUID", this.globals.XRSUser.GUID);
    formData.append("search", this.peopleSearchText);
    formData.append("filter", "AllPeople");
    formData.append("sort", "Created");
    formData.append("take", "" + 20);
    formData.append("skip", "" + 0);
    formData.append("callingFilter", "" + this.callingFilter);
    formData.append("User_GUID", "" + this.User_GUID);

    this.appservice.GetPeopleList(formData).subscribe((res) => {
      try {
        this.loadingDone = true;

        this.peopleList = JSON.parse(res.toString());
        if (this.peopleSelectedList === undefined) this.peopleSelectedList = [];

        if (this.peopleSelectedList !== undefined) {
          this.peopleList.forEach((element) => {
            let index = this.peopleSelectedList.find(
              (x) => x.GUID == element.GUID
            ).findIndex;

            if (index >= 0) {
              element.UserAssigned = true;
            } else {
              element.UserAssigned = false;
            }
          });
        } else {
          this.peopleSelectedList.forEach((element) => {
            element.UserAssigned = false;
          });
        }
      } catch (e) { }
    });

    return subject.asObservable();
  }

  onSubmit() {
    this.peopleList = null;
    this.GetPeopleList();
  }

  async closeModal() {
    await this.modalCtrl.dismiss(this.peopleSelectedList);
  }

  async onCloseUpload() {
    await this.modalCtrl.dismiss(this.peopleSelectedList);
  }
}
